import React from 'react';

const LocationsOverviewSection: React.FC = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">九州各地でサービスを提供</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            IDS教習所グループは九州各地に拠点を構え、農業ドローンと自動操舵システムの包括的なサポートを提供しています。
            各拠点では専門スタッフが皆様のニーズにお応えします。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">IDS佐賀教習所</h3>
            <p className="text-gray-600 mb-2 text-center">株式会社アイテム</p>
            <p className="text-teal-600 font-semibold text-center">DJI推薦修理センター認定</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">IDS川副教習所</h3>
            <p className="text-gray-600 mb-2 text-center">九三エンジニアリング株式会社</p>
            <p className="text-teal-600 font-semibold text-center">DJI認定整備士在籍</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">IDS鹿児島教習所</h3>
            <p className="text-gray-600 mb-2 text-center">株式会社エコナーセリー</p>
            <p className="text-teal-600 font-semibold text-center">DJI認定整備士在籍</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsOverviewSection;
